import * as React from "react";
import {Route, Switch} from "react-router-dom";
import {history} from "load/store";
import BsPdfUploadV2 from "BsPdfUploadV2";
import CategoryList from "IncompleteInfoV2/CategoryList";
import PanCard from "IncompleteInfoV2/PanCard";
import WorkDetails from "IncompleteInfoV2/WorkDetails";
import SelfieUpload from "IncompleteInfoV2/Selfie";
import ResidenceAddress from "IncompleteInfoV2/ResidenceAddress";
import LoanRequest from "IncompleteInfoV2/LoanRequest";
import OtherDocuments from "IncompleteInfoV2/OtherDocuments";
import References from "IncompleteInfoV2/References";
import AadhaarOkyc from "IncompleteInfoV2/Okyc";
import Kyc from "IncompleteInfoV2/Kyc";
import BankStatementV2 from "./BankStatementV2";
export let indexPath = null;

export enum routePaths {
    BANK_STATEMENT = "/bank-statement",
    BS_PDF_UPLOAD = "/bs-pdf-upload",
    SELFIE_UNCLEAR = "/selfie-unclear",
    PAN_UNCLEAR = "/pan-unclear",
    WORK_DETAILS = "/work-details",
    RESIDENCE_ADDRESS = "/residence-address",
    OTHER_DOCS = "/documents",
    LOAN_REQUEST = "/loan-request",
    REFERENCES = "/references",
    AADHAAR_OKYC = "/okyc",
    KYC = "/kyc",
}

export function getRoutes(path: string) {
    return (
        <Switch>
            <Route exact path={`${path}${routePaths.BANK_STATEMENT}`} component={BankStatementV2}/>
            <Route exact path={`${path}${routePaths.BS_PDF_UPLOAD}`} component={BsPdfUploadV2}/>
            <Route exact path={`${path}${routePaths.PAN_UNCLEAR}`} component={PanCard}/>
            <Route exact path={`${path}${routePaths.WORK_DETAILS}`} component={WorkDetails}/>
            <Route exact path={`${path}${routePaths.SELFIE_UNCLEAR}`} component={SelfieUpload}/>
            <Route exact path={`${path}${routePaths.RESIDENCE_ADDRESS}`} component={ResidenceAddress}/>
            <Route exact path={`${path}${routePaths.LOAN_REQUEST}`} component={LoanRequest}/>
            <Route exact path={`${path}${routePaths.OTHER_DOCS}`} component={OtherDocuments}/>
            <Route exact path={`${path}${routePaths.REFERENCES}`} component={References}/>
            <Route exact path={`${path}${routePaths.AADHAAR_OKYC}`} component={AadhaarOkyc}/>
            <Route path={`${path}${routePaths.KYC}`} component={Kyc}/>
            <Route exact path={`${path}`} component={CategoryList}/>
        </Switch>
    );
}

export function setIndexPath(path: string) {
    indexPath = path;
}
export function handleNavigation(navigateToPath: string) {
    if (indexPath) {
        history.push({pathname: `${indexPath}${navigateToPath}`});
    }
}
